import { useEffect } from "react";
import { ChallengeScheme } from "client-v2";

import "./feed.css";
import { QueryResponsePagination } from "client-v2/lib/browser/contracts/sdk/Query";

const BirthdayView = (props: Props) => {
	useEffect(() => {
		// const type = "dream";
		// get_challenge_feed(type);
		get_feed();
	}, []);

	let page = 0;
	let html = ``;

	function render_cell(challenge: { obj: ChallengeScheme; amount: number }) {
		const fechaObjetivo: any = new Date(challenge.obj.endDate.iso);
		const hoy: any = new Date();
		const days_between = Math.round(
			Math.abs((fechaObjetivo - hoy) / (1000 * 60 * 60 * 24))
		);
		const isCompleted =
			challenge.obj.type === "birthday"
				? new Date(challenge.obj.endDate.iso) < new Date()
				: challenge.obj.amount >= challenge.obj.goal;

		//Challenge cell
		html += `
			<div class="cell" onclick="window.open('https://adoptaunabuelo.org/${
				challenge.obj.type === "birthday"
					? "cumpleanios"
					: challenge.obj.type === "dream"
					? "reto"
					: "firma"
			}?id=${challenge.obj.objectId}')">
				<div class="challenge-image-view">
					<div class="badge ${isCompleted ? "" : "hidden"}">
						<p>Completado</p>
					</div>
					<img class="challenge-image" src="${challenge.obj.image?.url}"/>
				</div>
				<div class="data">
					<p style="font-weight: 500; margin-bottom: 12px; min-height: 50px;">${challenge.obj.title}</p>
					${
						challenge.obj.type !== "birthday"
							? `
						<div class="progress">
							<div class="bar ${isCompleted && "completed"}" style="width: ${
									(challenge.obj.amount /
										challenge.obj.goal) *
									100
							  }%;"></div>
						</div>
					`
							: ""
					}
						${
							challenge.obj.type === "birthday"
								? `<div class="row">
									<img
										class="lucide-icon"
										src="https://unpkg.com/lucide-static@latest/icons/heart.svg"
									/>
									<p><span class="primary">${challenge.amount} felicitaciones</span></p>
								</div>`
								: `<p style="margin-bottom: 12px; color: rgba(0, 29, 61, 0.56);"><span class="${
										isCompleted ? "success" : "primary"
								  }">${challenge.obj.amount} €</span> de ${
										challenge.obj.goal
								  } €</p>`
						}
					${
						challenge.obj.type === "dream"
							? `
						<div class="row">
							<img
								class="lucide-icon"
								src="https://unpkg.com/lucide-static@latest/icons/users.svg"
							/>
							${`<p><span>${challenge.obj.supporters} personas</span> han colaborado</p>`}
						</div>
					`
							: ""
					}
					<div class="row">
						<img
							class="lucide-icon"
							src="https://unpkg.com/lucide-static@latest/icons/calendar.svg"
						/>
						${
							isCompleted
								? "Completado"
								: challenge.obj.type === "birthday"
								? `<p><span>${days_between} días</span> para su cumpleaños</p>`
								: `<p><span>${
										new Date(challenge.obj.endDate.iso) <
										new Date()
											? "0"
											: days_between
								  } días</span> para cerrar la campaña</p>`
						}
					</div>
				</div>
			</div>
		`;
	}

	function get_feed() {
		const contenedor = document.getElementById("feed-content");
		if (!contenedor) return;
		fetch(`https://aua.b4a.io/v4/feed/web/?version=1`)
			.then((response) => response.json())
			.then((result) => {
				result.data.forEach((challenge: any) => {
					render_cell(challenge);
				});
				contenedor.innerHTML = html;
			});
	}

	function get_challenge_feed(type: string) {
		const contenedor = document.getElementById("feed-content");
		if (!contenedor) return;
		fetch(
			`https://aua.b4a.io/v4/feed/web/?version=1&type=${type}&limit=${
				page === 0 ? 8 : 9
			}&page=${page}`
		)
			.then((response) => response.json())
			.then(
				(result: {
					data: { obj: ChallengeScheme; amount: number }[];
					pagination: QueryResponsePagination;
				}) => {
					//Main feed cell
					result.data.forEach((challenge) => {
						render_cell(challenge);
					});
					//Hide load button
					if (
						result.pagination.currentPage + 1 >=
						result.pagination.totalPages
					) {
						const loadMoreButton =
							document.getElementById("load-more-button");
						if (loadMoreButton) {
							loadMoreButton.style.display = "none";
						}
					}
					//Create the last cell
					contenedor.innerHTML =
						html +
						`
                        <div class="cell last">
                            <p style="font-size: 20px; font-weight: 500; line-height: 28px; margin-bottom: 8px; text-align: center;">
                                ${
									type === "birthday"
										? "¿Quieres celebrar el cumpleaños de una persona mayor?"
										: "¿Quieres cumplir el sueño de una persona mayor?"
								}
                            </p>
                            <p style="text-align: center; color: rgba(0, 29, 61, 0.56);">
                                Escríbenos con todos los detalles a info@adoptaunabuelo.org 
                            </p>
                        </div>
                    `;
				}
			);
	}

	// Escuchar el click en el botón
	const loadMoreButton = document.getElementById("load-more-button");
	if (loadMoreButton) {
		loadMoreButton.addEventListener("click", () => {
			page++;
			get_challenge_feed("dream");
		});
	}

	return (
		<div className="feed-view scroll">
			<div className="feed-container scroll" id="feed-content"></div>
			<button id="load-more-button">Mostrar más</button>
		</div>
	);
};
export default BirthdayView;
export interface Props {}
